import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type DeleteAlertDialogProps = {
    handleDeleteAction: () => void;
    trigger?: ReactNode;
    title: string;
    description: string;
    asChild?: boolean;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
};

const DeleteAlertDialog = ({
    trigger,
    handleDeleteAction,
    title,
    description,
    asChild = false,
    open,
    onOpenChange,
}: DeleteAlertDialogProps) => {
    const { t } = useTranslation();

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            {trigger !== undefined && (
                <AlertDialogTrigger asChild={asChild}>
                    {trigger}
                </AlertDialogTrigger>
            )}
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {description}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>
                        {t("deleteAlert.cancel")}
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={handleDeleteAction}>
                        {t("deleteAlert.continue")}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default DeleteAlertDialog;
